<template>
  <div class="list">
    <top-header :type="6" :placeholder="'便民服务'" :hasBorder="true" :bgColor="'#fff'" fontSize="0.32rem" />
    <router-link to="/hxLook" class="row m_flex_box flex_vc flex_jz">
      <div class="left m_flex_box flex_vc">
        <img src="@/assets/img/icon/01.png" alt="">
        <div>
          <h3>户型图查询</h3>
          <p>商品房户型图查询</p>
        </div>
      </div>
      <van-icon name="arrow" />
    </router-link>
    <router-link to="/keepOnRecord" class="row m_flex_box flex_vc flex_jz">
      <div class="left m_flex_box flex_vc">
        <img src="@/assets/img/icon/1.png" alt="">
        <div>
          <h3>商品房备案查询</h3>
          <p>商品房房屋备案状态快查</p>
        </div>
      </div>
      <van-icon name="arrow" />
    </router-link>
    <router-link to="/myContract" class="row m_flex_box flex_vc flex_jz">
      <div class="left m_flex_box flex_vc">
        <img src="@/assets/img/icon/2.png" alt="">
        <div>
          <h3>商品房合同查询</h3>
          <p>商品房合同信息查验</p>
        </div>
      </div>
      <van-icon name="arrow" />
    </router-link>
    <router-link to="/announcePre" class="row m_flex_box flex_vc flex_jz">
      <div class="left m_flex_box flex_vc">
        <img src="@/assets/img/icon/3.png" alt="">
        <div>
          <h3>预售公示及查询</h3>
          <p>商品房预售许可公示及查询</p>
        </div>
      </div>
      <van-icon name="arrow" />
    </router-link>
    <router-link to="/announceNow" class="row m_flex_box flex_vc flex_jz">
      <div class="left m_flex_box flex_vc">
        <img src="@/assets/img/icon/4.png" alt="">
        <div>
          <h3>现售公示及查询</h3>
          <p>商品房现售许可公示及查询</p>
        </div>
      </div>
      <van-icon name="arrow" />
    </router-link>
    <router-link to="/oneHouse" class="row m_flex_box flex_vc flex_jz">
      <div class="left m_flex_box flex_vc">
        <img src="@/assets/img/icon/5.png" alt="">
        <div>
          <h3>一房一价查询</h3>
          <p>商品房未售房源一房一价</p>
        </div>
      </div>
      <van-icon name="arrow" />
    </router-link>
    <router-link to="/myStockRoomContract" class="row m_flex_box flex_vc flex_jz">
      <div class="left m_flex_box flex_vc">
        <img src="@/assets/img/icon/6.png" alt="">
        <div>
          <h3>二手房合同查询</h3>
          <p>二手房网签合同查验</p>
        </div>
      </div>
      <van-icon name="arrow" />
    </router-link>
    <router-link to="/myContract" class="row m_flex_box flex_vc flex_jz">
      <div class="left m_flex_box flex_vc">
        <img src="@/assets/img/icon/7.png" alt="">
        <div>
          <h3>商品房合同密码修改</h3>
          <p>商品房合同密码在线修改</p>
        </div>
      </div>
      <van-icon name="arrow" />
    </router-link>
    <router-link to="/myArgument" class="row m_flex_box flex_vc flex_jz">
      <div class="left m_flex_box flex_vc">
        <img src="@/assets/img/icon/8.png" alt="">
        <div>
          <h3>购房评价</h3>
          <p>业主真实购房评价</p>
        </div>
      </div>
      <van-icon name="arrow" />
    </router-link>
    <router-link to="/myClfArgumentList" class="row m_flex_box flex_vc flex_jz">
      <div class="left m_flex_box flex_vc">
        <img src="@/assets/img/icon/8.png" alt="">
        <div>
          <h3>二手房网签评价</h3>
          <p>二手房交易网签评价</p>
        </div>
      </div>
      <van-icon name="arrow" />
    </router-link>
    <router-link to="/downLoad" class="row m_flex_box flex_vc flex_jz">
      <div class="left m_flex_box flex_vc">
        <img src="@/assets/img/icon/9.png" alt="">
        <div>
          <h3>下载中心</h3>
          <p>开发企业下载中心</p>
        </div>
      </div>
      <van-icon name="arrow" />
    </router-link>

    <a href="http://www.xzzbzx.com/appPath/zydjapply" class="row m_flex_box flex_vc flex_jz">
      <div class="left m_flex_box flex_vc">
        <img src="@/assets/img/icon/10.png" alt="">
        <div>
          <h3>经适房特殊情况</h3>
          <p>经适房特殊情况转移登记</p>
        </div>
      </div>
      <van-icon name="arrow" />
    </a>

    <a href="http://www.xzzbzx.com/appPath/ssjyapply" class="row m_flex_box flex_vc flex_jz"><!--/myHouseDeal-->
      <div class="left m_flex_box flex_vc">
        <img src="@/assets/img/icon/11.png" alt="">
        <div>
          <h3>经适房上市交易</h3>
          <p>经适房上市交易</p>
        </div>
      </div>
      <van-icon name="arrow" />
    </a>

    <router-link to="/buyHouse" class="row m_flex_box flex_vc flex_jz">
      <div class="left m_flex_box flex_vc">
        <img src="@/assets/img/icon/32.png" alt="">
        <div>
          <h3>我要买房</h3>
          <p>买新房、二手房一键求房</p>
        </div>
      </div>
      <van-icon name="arrow" />
    </router-link>
    <router-link to="/IWillBuy" class="row m_flex_box flex_vc flex_jz">
      <div class="left m_flex_box flex_vc">
        <img src="@/assets/img/icon/33.png" alt="">
        <div>
          <h3>我要求购</h3>
          <p>发布购房需求全城找房</p>
        </div>
      </div>
      <van-icon name="arrow" />
    </router-link>

    <router-link to="/escrowAgreement" class="row m_flex_box flex_vc flex_jz">
      <div class="left m_flex_box flex_vc">
        <img src="@/assets/img/icon/31.png" alt="">
        <div>
          <h3>二手房监管协议查询</h3>
          <p>二手房交易资金监管协议查验</p>
        </div>
      </div>
      <van-icon name="arrow" />
    </router-link>
  </div>
</template>

<script>
import topHeader from '@/components/header';
export default {
  data() {
    return {
    };
  },
  components: {
    topHeader
  },
  mounted() {},
  methods: {},
};
</script>
<style lang="less" scoped>
.list{
  width: 7.04rem;
  margin: 0 auto;
  .row{
    width: 100%;
    padding: 0.3rem 0;
    border-bottom: 1px solid #f5f5f5;
    img{
      width: 0.76rem;
      height: 0.76rem;
      margin-right: 0.34rem;
    }
    .left{
      h3{
        font-size: 0.3rem;
        color: #101010;
        // font-weight: 800;
      }
      p{
        font-size: 0.24rem;
        color: #A0A0A0;
      }
    }
    i{
      font-size: 0.26rem;
      color: #A0A0A0;
    }
  }
}
</style>